import styled from '../../config/theme'

const Container = styled.div`
  width: 100% !important;
  overflow-x: auto;

  table {
    display: table;
    width: 100%;
    border-collapse: collapse;
    color: #7c8798;

    td {
      word-break: break-all;
    }

    thead {
      background: white;

      th {
        padding: 1rem;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #e8eef3;
        white-space: nowrap;
        border: 1px solid #e8eef3;
        font-weight: 500;
        font-size: 14px;
      }
    }
    tbody {
      background: white;

      tr {
        cursor: pointer;
        &:hover {
          filter: opacity(.5);
        }

        &:nth-of-type(odd) {
          background-color: #f4f8fb;
        }

        td {
          border: 1px solid #e8eef3;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 300px
          padding: 1rem;
          vertical-align: top;
          white-space: nowrap;
        }
      }

    }
  }
`

export {
  Container,
}
